export default __webpack_public_path__ + "static/media/purpleArrow.9cc29c73.svg";